<template lang="pug">
  .dynamic-right-panel
    transition(name="slideright" mode="out-in")
        .md-layout-item.md-content.right(md-theme="white" v-if="currentComponent")
            component(v-bind:is="currentComponent")
</template>
<script>
  import User from '@/modules/users/views/User.vue';
  export default {
    name: 'dynamic-right-panel',
    props: [],
    components: {User},
    data() {
        return {
            currentComponent: null,
            query: {
                old: {},
                new: {}
            }
        }
    },
    created() {
      this.$nextTick(() => this.init());
    },
    watch: {
    },
    computed: {

    },
    methods: {
        init() {
            this.listeners();
        },
        listeners() {
            this.$root.$on('show-dynamic-right-panel', (component, query) => {
                this.$store.commit('openRightPanel');
                
                this.query.old = Object.assign({}, this.$route.query);
                this.query.new = {};
                if (query) Object.keys(query).map(key => this.query.new[key] = query[key]);
                if (this.$route.query) Object.keys(this.$route.query).map(key => this.query.new[key] = this.$route.query[key]);
                this.query.new.dynamic = true;

                this.$router.push({name: this.$route.name, params: this.$route.params, query: this.query.new});
                this.currentComponent = component;
            });
            this.$root.$on('hide-dynamic-right-panel', () => {                
                this.currentComponent = null;
                this.$store.commit('closeRightPanel');
                this.query.new = {};
                this.query.old = {};
                this.$router.push({name: this.$route.name, params: this.$route.params, query: this.query.old});
            });
        }
    }
  }
</script>
<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// DynamicRightPanel.vue?44c4fdee